var _g, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalableTeamsL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 288,
    viewBox: "0 0 407 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_4125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 0.127686C319.777 0.127686 638.605 0.127686 957.432 0.127686C957.083 249.982 957.083 499.837 957.432 749.691C638.615 749.949 319.787 749.949 0.949219 749.691V0.127686Z",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 428.451H138.527C159.499 428.451 182.194 430.705 202.297 425.88C230.535 419.107 252.421 398.316 271.506 381.787C304.971 352.779 353.312 287.414 406.327 279.748C452.766 273.056 510.679 325.238 541.463 345.676C583.647 373.675 622.116 402.39 676.195 412.932C716.222 420.75 747.41 435.671 783.513 450.662C814.581 463.576 854.533 476.653 887.774 460.054C914.544 446.694 921.809 432.067 957.417 428.463",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 285.688C168.802 285.688 337.059 288.494 504.747 282.249C598.717 278.727 689.917 275.205 783.228 265.25C814.177 261.963 874.068 250.376 903.069 264.229C909.601 267.351 911.144 272.259 916.761 275.733C930.468 284.174 939.456 285.031 957.432 285.688",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 249.977C166.78 249.977 332.924 252.325 498.65 247.37C539.291 246.138 580.022 246.067 620.618 244.776C673.169 243.109 724.626 230.125 775.633 221.133C807.226 215.557 869.184 200.143 898.47 218.092C922.813 232.954 919.982 247.711 957.432 250",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 214.292C163.783 214.292 326.783 215.971 489.572 212.895C527.022 212.191 565.312 213.729 602.582 211.24C657.904 207.566 712.012 187.08 764.188 173.333C798.642 164.259 860.495 142.952 892.104 167.464C917.72 187.315 915.113 209.139 957.507 214.304",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 178.59C161.237 178.59 321.525 179.306 481.812 178.249C516.267 178.026 552.713 180.597 587.063 177.475C644.901 172.239 701.526 144.78 754.316 127.065C791.766 114.528 852.241 88.7831 886.411 118.66C913.375 142.221 911.143 170.924 957.507 178.531",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 142.902H479.191C512.821 142.902 548.444 145.567 581.925 142.526C640.662 137.197 697.916 107.108 750.721 88.0318C788.965 74.2145 848.422 47.742 883.595 78.8163C911.143 103.164 910.245 134.943 957.447 142.89",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 107.251H479.191C512.971 107.251 548.339 109.669 581.999 106.817C636.647 102.191 689.587 78.7358 740.07 63.0871C780.876 50.4438 831.629 31.3907 871.086 55.75C902.545 75.167 914.169 100.606 957.462 107.227",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 71.5149H479.191C513.196 71.5149 547.695 72.8767 581.655 71.4092C629.592 69.3431 676.03 55.291 722.034 45.4768C764.338 36.4609 807.631 28.4429 850.129 41.0745C887.58 52.1683 916.042 68.8735 957.432 71.5149",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 35.8173H479.191C555.41 35.8173 628.992 34.0681 704.702 27.224C746.077 23.4791 788.591 22.0234 829.996 25.6392C872.794 29.3723 914.065 36.2047 957.402 35.8525",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.419 0.12793C456.419 67.6297 450.277 137.151 461.452 204.218C466.366 233.708 471.744 262.645 473.436 292.393C473.601 295.34 471.818 312.608 477.526 315.872C483.009 319.03 486.963 315.872 491.323 317.586C495.682 319.3 499.562 315.837 505.104 319.3C511.201 323.115 509.688 337.414 508.834 342.837C502.842 380.744 453.093 413.274 424.706 441.824C382.627 484.086 385.233 511.017 400.738 562.259C419.628 624.596 447.985 685.664 456.314 749.632",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.866 0.12793C410.866 59.4356 409.833 118.802 410.701 178.11C411.091 204.242 412.858 230.35 413.697 256.47C414.102 270.628 406.342 301.409 417.532 312.632C429.262 306.163 430.7 292.675 442.414 286.242C475.73 326.156 357.552 401.288 337.119 432.092C310.993 471.443 339.621 523.167 353.193 562.682C374.389 624.443 401.249 685.946 410.926 749.632",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.327 0.127686V256.846C365.327 270.733 357.762 301.819 369.132 312.714C380.187 304.496 381.116 290.796 392.187 282.59C424.888 319.675 310.02 398.282 290.891 427.514C264.631 467.686 293.123 519.081 306.845 559.441C328.191 622.294 355.141 684.924 365.267 749.62",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.772 0.127686V204.887C319.772 234.787 318.828 264.758 319.772 294.694C319.772 294.752 318.664 315.379 322.768 316.999C324.191 317.539 332.82 317.057 331.487 316.106C330.738 315.566 338.018 314.169 340.19 315.226C345.283 317.703 343.186 333.446 342.587 337.531C337.718 372.467 303.639 403.8 281.977 433.266C249.935 476.772 253.77 505.734 267.177 554.499C285.018 619.453 310.994 683.41 319.772 749.656",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.231 0.127686V204.887C274.231 250.8 268.569 298.439 280.463 343.53C294.065 395.183 274.306 436.717 253.499 485.413C216.662 571.615 269.378 662.256 274.246 749.703",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.679 0.127686C228.679 122.312 224.185 245.118 230.177 367.232C232.787 421.69 230.369 476.225 222.942 530.41C213.13 603.723 230.192 676.449 228.694 749.738",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.139 0.127686V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.586 0.12793V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.043 0.12793V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4863 0.127686V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 131.442,
    width: 398.512,
    height: 156.558,
    fill: "url(#paint0_linear_255_4125)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 250.15,
    y: 251.163,
    width: 250.326,
    height: 156.558,
    transform: "rotate(-90 250.15 251.163)",
    fill: "url(#paint1_linear_255_4125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_4125",
    x1: 200.756,
    y1: 131.442,
    x2: 200.756,
    y2: 288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_4125",
    x1: 375.313,
    y1: 251.163,
    x2: 375.313,
    y2: 407.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_4125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.662109 25.1163C0.662109 11.2449 11.9071 0 25.7784 0H406.709V277.116H0.662109V25.1163Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalableTeamsL);
export default __webpack_public_path__ + "static/media/scalable-teams-l.93de42b437f8fb6c5582b7d737593d7b.svg";
export { ForwardRef as ReactComponent };